// extracted by mini-css-extract-plugin
export default {"wrapper":"BC-z","viewport":"CC-z","container":"DC-z","slide":"EC-z"};